import { EXECUTE_RESOLUTION, EXECUTE_RESOLUTION_SUCCESS, EXECUTE_RESOLUTION_ERROR, EXECUTE_RESOLUTION_EMPTY } from '../../actions';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const ExecuteResolution = (state = initialState, action) => {
  switch (action.type) {
    case EXECUTE_RESOLUTION:
      state = {
        ...state,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case EXECUTE_RESOLUTION_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case EXECUTE_RESOLUTION_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case EXECUTE_RESOLUTION_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default ExecuteResolution;
